import React from 'react'
import './../../App.css'

const Navbar = () =>{
    return(
 <footer>
     <p>Designed with <i className = "fa fa-heart"> </i> by Judith</p >
 </footer>
    )
}
export default Navbar